// extracted by mini-css-extract-plugin
module.exports = {"resultText":"UserFilters_result-text__WHwL6"};